import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column flex-md-row align-items-center p-3 px-md-4 mb-3 bg-white border-bottom box-shadow" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h5", { class: "my-0 mr-md-auto font-weight-normal" }, "Transliterator", -1)
const _hoisted_3 = { class: "my-2 my-md-0 mr-md-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("nav", _hoisted_3, [
      _createVNode(_component_router_link, {
        class: "p-2 text-dark",
        to: "/"
      }, {
        default: _withCtx(() => [
          _createTextVNode("Home")
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        class: "p-2 text-dark",
        to: "/convert"
      }, {
        default: _withCtx(() => [
          _createTextVNode("Converter")
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        class: "p-2 text-dark",
        to: "/write"
      }, {
        default: _withCtx(() => [
          _createTextVNode("Write")
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        class: "p-2 text-dark",
        to: "/ocr"
      }, {
        default: _withCtx(() => [
          _createTextVNode("OCR")
        ]),
        _: 1
      })
    ])
  ]))
}